module.exports = __webpack_public_path__ + "img/_homePad_resolve_logo.58513d51.svg";